import React, { forwardRef, ReactNode } from "react";

export interface FontTextProps
  extends React.HTMLAttributes<HTMLParagraphElement> {
  children?: ReactNode;
  size?: number;
  color?: string;
  font?: "notoSans";
  align?: "center" | "auto" | "left" | "right" | "justify" | undefined;
  lineHeight?: number;
  weight?: "100" | "300" | "400" | "500" | "700" | "900" | "bold" | "normal";
}

export const FontText = forwardRef<HTMLParagraphElement, FontTextProps>(
  (
    {
      children,
      size = 14,
      color,
      style,
      weight,
      align,
      lineHeight,
      ...restProps
    },
    ref
  ) => {
    let fontFamily;
    switch (weight) {
      case "100":
        fontFamily = "SUIT-Thin";
        break;
      case "300":
        fontFamily = "SUIT-Light";
        break;
      case "400":
        fontFamily = "SUIT-Regular";
        break;
      case "500":
        fontFamily = "SUIT-Medium";
        break;
      case "700":
        fontFamily = "SUIT-Bold";
        break;
      case "900":
        fontFamily = "SUIT-ExtraBold";
        break;
      case "bold":
        fontFamily = "SUIT-Bold";
        break;
      default:
        fontFamily = "SUIT-Regular";
        break;
    }

    const textStyle: React.CSSProperties = {
      fontFamily,
      lineHeight: lineHeight ? `${lineHeight}px` : `${size}px`,
      paddingTop: lineHeight ? undefined : `${size * 0.2}px`,
      fontSize: `${size}px`,
      color: color || "black",
      // textAlign: align,
      ...style,
    };

    return (
      <p ref={ref} style={textStyle} {...restProps}>
        {children}
      </p>
    );
  }
);
